"use client";
import Close from '@/projectRoot/src/components/common/svg/Close';
import style from './chosenFilters.module.scss';
import { useFilters } from '@/projectRoot/src/contexts/FiltersContext';
import { getSpecificCategory } from '@/projectRoot/src/utils/handlers/categoriesHandler';

interface Props {
    classes?: string[];
}

const ChosenFilters = ({classes = []}: Props) => {
  const {filters, state, dispatch} = useFilters();
  return (
    <div className={`${style.chosenFilters} ${classes.join(' ')}`}>
      {
        state.price_min || state.price_max
          ?
          <p className={style.filter}>
            od {state.price_min} do {state.price_max}
            <span
              className={style.eraseIcon}
              onClick={() =>
                dispatch({ type: "updatePriceRange" })
              }
            >
              <Close width={10} height={10} hexColor="black" />
            </span>
          </p>
          :
          <></>
      }
      {/* {
        state.guides?.map((item) => {
          let guide = filters.options?.sizeGuides?.find(
            (size) => size.id == item.slice(0, item.indexOf('_'))
          );
          return (
            <p className={`${style.filter} ${!guide ? 'dNone' : ''}`} key={item}>
              {item.slice(item.indexOf('_') + 1)} ({guide?.title})
              <span
                className={style.closeIcon}
                onClick={() => dispatch({ type: "updateSizeGuides", payload: item })}
              >
                <Close width={9} height={9} hexColor="black" />
              </span>
            </p>
          );
        })
      } */}
      {
        state.category_ancestor_ids?.map((catId) => {
          let category = filters.options?.categories.find(cat => cat.id == catId);
          return (
            <p className={`${style.filter} ${!category ? 'dNone' : ''}`} key={catId}>
              {category?.title}
              <span
                className={style.eraseIcon}
                onClick={() => dispatch({ type: "updateAncestorCategories", payload: catId })}
              >
                <Close width={9} height={9} hexColor="black" />
              </span>
            </p>
          );
        })
      }
      {
        state.category_ids?.map((catId) => {
          let category = filters.options?.categories.find(cat => cat.id == catId);
          if (!category) {
            filters.options.categories.map(cat => {
              if(category) return;
              category = getSpecificCategory(cat.children ?? [], catId)
            }
            );
          }
          return (
            <p className={`${style.filter} ${!category ? 'dNone' : ''}`} key={catId}>
              {category?.title}
              <span
                className={style.eraseIcon}
                onClick={() => dispatch({ type: "updateCategories", payload: catId })}
              >
                <Close width={9} height={9} hexColor="black" />
              </span>
            </p>
          );
        })
      }
      {
        state.brand_ids?.map((item) => {
          let brand = filters.options?.brands?.find((br) => br.id == item);
          return (
            <p className={`${style.filter} ${!brand ? 'dNone' : ''}`} key={item}>
              {brand?.title}
              <span
                className={style.eraseIcon}
                onClick={() => dispatch({ type: "updateBrands", payload: item })}
              >
                <Close width={10} height={10} hexColor="black" />
              </span>
            </p>
          );
        })
      }
      {
        state.stock_variants?.map((item) => (
          <p className={style.filter} key={item}>
            {item}
            <span
              className={style.eraseIcon}
              onClick={() => dispatch({ type: "updateSizes", payload: item })}
            >
              <Close width={10} height={10} hexColor="black" />
            </span>
          </p>
        ))
      }
      {
        state.label_ids?.map((item) => {
          let label = filters.options?.labels?.find((lab) => lab.id == item);
          return (
            <p className={`${style.filter} ${!label ? 'dNone' : ''}`} key={item}>
              {label?.title}
              <span
                className={style.eraseIcon}
                onClick={() => dispatch({ type: "updateLabels", payload: item })}
              >
                <Close width={10} height={10} hexColor="black" />
              </span>
            </p>
          );
        })
      }
      {
        state.collection_ids?.map((item) => {
          let collection = filters.options?.collections?.find(
            (col) => col.id == item
          );
          return (
            <p className={`${style.filter} ${!collection ? 'dNone' : ''}`} key={item}>
              {collection?.title}
              <span
                className={style.eraseIcon}
                onClick={() =>
                  dispatch({ type: "updateCollections", payload: item })
                }
              >
                <Close width={10} height={10} hexColor="black" />
              </span>
            </p>
          );
        })
      }
      
      {
        state.color_ids?.map((item) => {
          let color = filters.options?.colors?.find((color) => color.id == item);
          return (
            <p className={style.filter} key={item}>
              {color?.title}
              <span
                className={style.icon}
                style={color?.hex ? { backgroundColor: color.hex } : {}}
              >
                {color?.image_icon_url ? (
                  <img
                    src={color.image_icon_url}
                    width={15}
                    height={15}
                    alt={color.title ?? 'title'}
                  />
                ) : (
                  <></>
                )}
              </span>
              <span
                className={style.eraseIcon}
                onClick={() => dispatch({ type: "updateColors", payload: item })}
              >
                <Close width={10} height={10} hexColor="black" />
              </span>
            </p>
          );
        })
      }
    </div>
  )
};

export default ChosenFilters;
